$('document').ready(() => {
    let tabsCaptionActiveClass = 'tabs__caption-item--active';
    let tabsContentActiveClass = 'tabs__content-item--active';
    $('.product-features-slider__item').click((e) => {
        let dataValue = ($(e.currentTarget).data('detail'));
        $('[data-tab="detail"]')
            .addClass(tabsCaptionActiveClass)
            .siblings()
            .removeClass(tabsCaptionActiveClass);
        $('[data-tab="detail"]')
            .parents('.tabs')
            .find(`.tabs__content-item`)
            .removeClass(tabsContentActiveClass)
            .eq($('[data-tab="detail"]').index())
            .addClass(tabsContentActiveClass);
        let detailItemTopPos = $(`.product-detail__item[data-detail="${dataValue}"]`).position().top;
        window.scrollTo({
            top: detailItemTopPos,
            behavior: 'smooth'
        })
    })
    $('[data-link]').click((e) => {
        e.preventDefault();

        const dataId = e.currentTarget.dataset.link;
        const content = $(`[data-tab="${dataId}"]`);

        content
            .addClass(tabsCaptionActiveClass)
            .siblings()
            .removeClass(tabsCaptionActiveClass);
        content
            .parents('.tabs')
            .find(`.tabs__content-item`)
            .removeClass(tabsContentActiveClass)
            .eq(content.index())
            .addClass(tabsContentActiveClass);
        let tabsTopPos = content.position().top;
        window.scrollTo({
            top: tabsTopPos,
            behavior: 'smooth'
        })
    })
})
